// extracted by mini-css-extract-plugin
export var autoExpand = "_2o-8";
export var container = "_2o-7";
export var containerWidth = "_2o-5";
export var disabled = "_2o-2";
export var error = "_2o-3";
export var fullWidth = "_2o-6";
export var inputWrapper = "_2o-0";
export var small = "_2o-1";
export var textarea = "_2o-4";